<div class="history-drawer-container">
  <div class="header-history-drawer">
    <div class="header-history-drawer-container">
      <p-dropdown
        [options]="optionsImei"
        [(ngModel)]="currentSelectedImei"
        [filter]="true"
        filterBy="name"
        optionLabel="name"
        placeholder="Seleccione un historial"
        class="w-dropdown"
        (onChange)="onImeiSelect()"
      >
      </p-dropdown>
      <button class="button-icon" (click)="showDialog()">
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#folder-managed"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">folder</mat-icon>
        Gestionar historial
      </button>
    </div>
    <div class="header-history-drawer-container">
      <button
        class="button-icon"
        (click)="currentHistory && refreshHistory(currentHistory)"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#refresh"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">refresh</mat-icon>
      </button>

      <button
        class="button-icon"
        (click)="currentHistory && centerHistoryForMap(currentHistory)"
      >
        <mat-icon size="16" variant="outlined">center_focus_weak</mat-icon>
      </button>
      <button
        *appHasPermission="'history_dashboard'"
        class="button-icon"
        (click)="showDashboard()"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#chart-bar"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">bar_chart</mat-icon>
      </button>
      <button
        *appHasPermission="'history_settings'"
        class="button-icon"
        (click)="showSettingsDialog()"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#settings"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">settings</mat-icon>
      </button>
      <button
        *appHasPermission="'history_technical_parameters'"
        class="button-icon"
        (click)="showTechnicalParameters()"
        title="Parámetros Técnicos"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#code"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">code</mat-icon>
      </button>
      <button
        class="button-icon"
        [ngClass]="{ 'button-icon-active': !isShowAsideSection }"
        (click)="toggleShowAsideSection()"
      >
        <!-- <svg width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#view-sidebar"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">view_sidebar</mat-icon>
      </button>
    </div>
  </div>
  <div class="body-history-drawer">
    <div class="map-history-drawer card" #mapContainer></div>
    <toast-history-in-map
      *ngIf="!(loadingCreateHistory$ | async) && !(errorCreateHistory$ | async)"
      [message]="formatMessageToastHistory(currentHistory?.detailsHistory)"
      [iconClass]="'pi pi-calendar'"
    ></toast-history-in-map>
    <div
      class="aside-history-drawer card"
      [ngClass]="{ 'aside-history-drawer-hidden': !isShowAsideSection }"
    >
      <div class="aside-history-drawer-header">
        <h2>{{ getTitleAside(currentItemAside) }}</h2>
        <div>
          <button
            type="button"
            class="button-icon button-icon-transparent"
            aria-label="Opciones"
            (click)="asideMenu.toggle($event)"
          >
            <!-- <svg width="24" height="24" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#options"></use>
            </svg>-->
            <mat-icon size="24">more_vert</mat-icon>
          </button>
          <p-menu
            #asideMenu
            [model]="itemsAside"
            [popup]="true"
            [appendTo]="'body'"
          ></p-menu>
        </div>
      </div>
      <div class="aside-history-drawer-body">
        <ng-container *ngIf="historyData$ | async as historyData">
          <!-- Stops con Virtual Scrolling -->
          <ng-container *ngIf="currentItemAside === 'stops'">
            <stops-history-list
              [stops]="historyData.stops"
              [currentImei]="historyData.imei"
              [currentState]="currentState"
              (selectCard)="handleSelectCard($event)"
              (redirectTo)="handleRedirectTo($event)"
            ></stops-history-list>
          </ng-container>

          <!-- Frames con Virtual Scrolling -->
          <ng-container *ngIf="currentItemAside === 'frames'">
            <frames-history-list
              [frames]="historyData.frames"
              [currentImei]="historyData.imei"
              [currentState]="currentState"
              (selectCard)="handleSelectCard($event)"
              (redirectTo)="handleRedirectTo($event)"
            ></frames-history-list>
          </ng-container>

          <!-- Events con Virtual Scrolling -->
          <ng-container *ngIf="currentItemAside === 'events'">
            <events-history-list
              [events]="historyData.events"
              [currentImei]="historyData.imei"
              [currentState]="currentState"
              (selectCard)="handleSelectCard($event)"
              (redirectTo)="handleRedirectTo($event)"
            ></events-history-list>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- MANEJO DE DIALOG DE CREACIÓN DE HISTORIAL PERSONALIZADO -->
<p-dialog
  [header]="
    'Crear historial personalizado - ' + getNameUnit(dataHistoryDrawer.imei)
  "
  [(visible)]="displayDialogCustomHistory"
  [style]="{ width: '720px' }"
  [baseZIndex]="10000"
  [draggable]="false"
  (onHide)="handleHiddenDialogCustomHistory(flagHiddenDialogCustomHistory)"
  (onShow)="setDefaultCustomHistoryDates()"
>
  <form [formGroup]="customHistoryForm" class="history-form">
    <div class="row">
      <div class="field">
        <label>Fecha inicio</label>
        <input type="date" formControlName="start_date" />
        <div
          class="error"
          *ngIf="
            customHistoryForm.get('start_date')?.touched &&
            customHistoryForm.get('start_date')?.invalid
          "
        >
          Requerido o fuera de rango permitido
        </div>
      </div>
      <div class="field">
        <label>Hora inicio</label>
        <p-calendar
          formControlName="time_start"
          [timeOnly]="true"
          [showIcon]="true"
          icon="pi pi-clock"
          [appendTo]="'body'"
          [showSeconds]="true"
          hourFormat="24"
          placeholder="HH:MM:SS"
        ></p-calendar>
        <div
          class="error"
          *ngIf="
            customHistoryForm.get('time_start')?.touched &&
            customHistoryForm.get('time_start')?.invalid
          "
        >
          Formato HH:MM:SS
        </div>
      </div>
    </div>

    <div class="row">
      <div class="field">
        <label>Fecha fin</label>
        <input type="date" formControlName="end_date" />
        <div
          class="error"
          *ngIf="
            customHistoryForm.get('end_date')?.touched &&
            customHistoryForm.get('end_date')?.invalid
          "
        >
          Requerido o fuera de rango permitido
        </div>
      </div>
      <div class="field">
        <label>Hora fin</label>
        <p-calendar
          formControlName="time_end"
          [timeOnly]="true"
          [showIcon]="true"
          icon="pi pi-clock"
          [appendTo]="'body'"
          [showSeconds]="true"
          hourFormat="24"
          placeholder="HH:MM:SS"
        ></p-calendar>
        <div
          class="error"
          *ngIf="
            customHistoryForm.get('time_end')?.touched &&
            customHistoryForm.get('time_end')?.invalid
          "
        >
          Formato HH:MM:SS
        </div>
      </div>
    </div>

    <div
      class="form-errors"
      *ngIf="customHistoryForm.invalid"
    >
      <div *ngIf="customHistoryForm.errors?.startAfterEnd as e">
        {{
          e.reason === "date"
            ? "La fecha de inicio debe ser anterior o igual a la fecha fin."
            : "La hora de inicio debe ser anterior o igual a la hora."
        }}
      </div>
      <div *ngIf="customHistoryForm.errors?.olderThanAllowed as e">
        Las fechas no pueden ser anteriores a {{ e.maxDays }} días respecto a
        hoy.
      </div>
      <div *ngIf="customHistoryForm.errors?.rangeTooLarge as e">
        El rango máximo permitido es de {{ e.maxRangeDays }} días entre fecha
        inicio y fecha fin.
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <button class="btn btn--ghost" (click)="hideDialogCustomHistory()">
      Cancelar
    </button>
    <button
      class="btn btn--primary"
      [disabled]="customHistoryForm.invalid"
      (click)="handleCreateCustomHistory()"
    >
      Generar
    </button>
  </ng-template>
</p-dialog>
<div
  class="custom-dialog-overlay"
  *ngIf="displayDialogCustomHistory"
  (click)="handleHiddenDialogCustomHistory()"
></div>

<!-- MANEJO DE HISTORIALES -->
<p-dialog
  header="Gestor de historiales"
  [(visible)]="displayDialog"
  [style]="{ width: '720px' }"
  [baseZIndex]="10000"
  [draggable]="false"
  (onHide)="searchHistory.setValue('')"
>
  <div>
    <div class="dialog-header">
      <div class="search-container">
        <div class="search-input">
          <!-- Icono de búsqueda (magnifying glass) -->
          <i class="search-icon"></i>
          <input
            [formControl]="searchHistory"
            type="text"
            placeholder="Buscar historiales por placa, código o IMEI"
            class="search-field"
          />
        </div>
      </div>
    </div>

    <div class="cards-container">
      <card-history
        *ngFor="let history of historiesFiltered; trackBy: trackByHistory"
        [history]="adaptHistoryCard(history)"
        (showHistory)="handleShowHistory($event)"
        (deleteHistory)="handleDeleteHistory($event)"
      ></card-history>
    </div>
  </div>
  <ng-template pTemplate="footer"></ng-template>
</p-dialog>
<div
  class="custom-dialog-overlay"
  *ngIf="displayDialog"
  (click)="displayDialog = false"
></div>

<!-- DIALOG DE CONFIGURACIÓN -->
<p-dialog
  header="Configuración del Historial"
  [(visible)]="displayDialogSettings"
  [style]="{ width: '800px', maxHeight: '70vh' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [modal]="true"
  (onHide)="setLastValuesSettings()"
>
  <div class="settings-container">
    <!-- SECCIÓN: VISIBILIDAD DE ELEMENTOS -->
    <div
      *appHasPermission="'history_settings_visibility'"
      class="settings-section"
    >
      <div class="section-header">
        <!-- <svg
          width="20"
          height="20"
          fill="currentColor"
          class="section-icon icon-svg"
        >
          <use xlink:href="./assets/icons/sprite.svg#eye"></use>
        </svg> -->
        <mat-icon size="20" variant="outlined" class="section-icon icon-svg"
          >remove_red_eye</mat-icon
        >
        <h3>Visibilidad de Elementos</h3>
        <p class="section-description">
          Configura qué elementos del historial deseas mostrar siempre
        </p>
      </div>

      <div class="visibility-options">
        <div
          class="visibility-option"
          (click)="settings.showMovements = !settings.showMovements"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#route"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">route</mat-icon>
            <span>Movimientos</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showMovements"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="visibility-option"
          (click)="settings.showStops = !settings.showStops"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#stop"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">front_hand</mat-icon>
            <span>Paradas</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showStops"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="visibility-option"
          (click)="settings.showStartRoute = !settings.showStartRoute"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#play"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">play_circle</mat-icon>
            <span>Inicio de Ruta</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showStartRoute"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="visibility-option"
          (click)="settings.showEndRoute = !settings.showEndRoute"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#stop-circle"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">stop_circle</mat-icon>
            <span>Fin de Ruta</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showEndRoute"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="visibility-option"
          (click)="settings.showFrames = !settings.showFrames"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#dot"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">adjust</mat-icon>
            <span>Tramas</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showFrames"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="visibility-option"
          (click)="settings.showEvents = !settings.showEvents"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#alert"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">car_crash</mat-icon>
            <span>Eventos</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showEvents"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>
      </div>
    </div>

    <!-- SECCIÓN: VARIANTE DE TRAMA -->
    <div
      *appHasPermission="'history_settings_frame_variant'"
      class="settings-section"
    >
      <div class="section-header">
        <!-- <svg
          class="icon-svg"
          width="20"
          height="20"
          fill="currentColor"
          class="section-icon"
        >
          <use xlink:href="./assets/icons/sprite.svg#layers"></use>
        </svg> -->
        <mat-icon size="20" variant="outlined" class="section-icon icon-svg"
          >layers</mat-icon
        >
        <h3>Variante de Trama</h3>
        <p class="section-description">
          Selecciona cómo se mostrarán las tramas en el mapa
        </p>
      </div>

      <div class="frame-variant-options">
        <div
          class="variant-option"
          [class.selected]="settings.frameVariant === 'basic'"
        >
          <input
            type="radio"
            name="frameVariant"
            value="basic"
            [(ngModel)]="settings.frameVariant"
            id="variant-basic"
          />
          <label for="variant-basic">
            <div class="variant-preview basic">
              <div class="dot"></div>
            </div>
            <div class="variant-info">
              <span class="variant-name">Básica</span>
              <span class="variant-description">Solo punto</span>
            </div>
          </label>
        </div>

        <div
          class="variant-option"
          [class.selected]="settings.frameVariant === 'speed'"
        >
          <input
            type="radio"
            name="frameVariant"
            value="speed"
            [(ngModel)]="settings.frameVariant"
            id="variant-speed"
          />
          <label for="variant-speed">
            <div class="variant-preview speed">
              <div class="speed-indicator">85</div>
            </div>
            <div class="variant-info">
              <span class="variant-name">Velocidad</span>
              <span class="variant-description">Div con velocidad</span>
            </div>
          </label>
        </div>

        <div
          class="variant-option"
          [class.selected]="settings.frameVariant === 'time'"
        >
          <input
            type="radio"
            name="frameVariant"
            value="time"
            [(ngModel)]="settings.frameVariant"
            id="variant-time"
          />
          <label for="variant-time">
            <div class="variant-preview time">
              <div class="time-indicator">14:30</div>
            </div>
            <div class="variant-info">
              <span class="variant-name">Tiempo</span>
              <span class="variant-description">Div con tiempo</span>
            </div>
          </label>
        </div>

        <div
          class="variant-option"
          [class.selected]="settings.frameVariant === 'speed-time'"
        >
          <input
            type="radio"
            name="frameVariant"
            value="speed-time"
            [(ngModel)]="settings.frameVariant"
            id="variant-speed-time"
          />
          <label for="variant-speed-time">
            <div class="variant-preview speed-time">
              <div class="speed-time-indicator">
                <div class="speed">85</div>
                <div class="time">14:30</div>
              </div>
            </div>
            <div class="variant-info">
              <span class="variant-name">Velocidad y Tiempo</span>
              <span class="variant-description">Div con ambos datos</span>
            </div>
          </label>
        </div>
      </div>
    </div>

    <!-- SECCIÓN: CONFIGURACIÓN ADICIONAL -->
    <div
      *appHasPermission="'history_settings_additional'"
      class="settings-section"
    >
      <div class="section-header">
        <!-- <svg
          class="icon-svg"
          width="20"
          height="20"
          fill="currentColor"
          class="section-icon"
        >
          <use xlink:href="./assets/icons/sprite.svg#settings"></use>
        </svg> -->
        <mat-icon size="20" variant="outlined" class="section-icon icon-svg"
          >settings</mat-icon
        >
        <h3>Configuración Adicional</h3>
        <p class="section-description">
          Opciones avanzadas para la visualización
        </p>
      </div>

      <div class="additional-options">
        <div
          class="additional-option"
          (click)="settings.routeWithDirection = !settings.routeWithDirection"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#map"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">directions</mat-icon>
            <span>Modo Ruta con Dirección</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.routeWithDirection"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="additional-option"
          (click)="settings.animationDirection = !settings.animationDirection"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#map"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">directions_run</mat-icon>
            <span>Mostrar Direcciones Animadas</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.animationDirection"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          *appHasPermission="'history_settings_route_with_speed'"
          class="additional-option"
          (click)="settings.routeWithSpeed = !settings.routeWithSpeed"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#speedometer"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">speed</mat-icon>
            <span>Ruta de Velocidad</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.routeWithSpeed"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="additional-option"
          (click)="settings.showGeofences = !settings.showGeofences"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#polygon"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">pentagon</mat-icon>
            <span>Mostrar geocercas</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showGeofences"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="additional-option"
          (click)="
            settings.showCircularGeofences = !settings.showCircularGeofences
          "
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#circle"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">circle</mat-icon>
            <span>Mostrar geocercas circulares</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showCircularGeofences"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>

        <div
          class="additional-option"
          (click)="settings.showGeopoints = !settings.showGeopoints"
        >
          <div class="option-info">
            <!-- <svg class="icon-svg" width="18" height="18" fill="currentColor">
              <use xlink:href="./assets/icons/sprite.svg#map-pin"></use>
            </svg> -->
            <mat-icon size="18" variant="outlined">place</mat-icon>
            <span>Mostrar geopuntos</span>
          </div>
          <p-inputSwitch
            [(ngModel)]="settings.showGeopoints"
            (click)="$event.stopPropagation()"
          ></p-inputSwitch>
        </div>
      </div>
    </div>

    <!-- SECCIÓN: ACCIONES -->
    <div class="settings-actions">
      <button class="btn btn--secondary" (click)="restoreDefaultSettings()">
        <!-- <svg class="icon-svg" width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#refresh"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">refresh</mat-icon>
        Restaurar Configuración
      </button>

      <button class="btn btn--primary" (click)="recreateHistory()">
        <!-- <svg class="icon-svg" width="16" height="16" fill="currentColor">
          <use xlink:href="./assets/icons/sprite.svg#plus"></use>
        </svg> -->
        <mat-icon size="16" variant="outlined">add</mat-icon>
        Volver a Crear Historial
      </button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn btn--ghost" (click)="hideSettingsDialog()">
      Cancelar
    </button>
    <button class="btn btn--primary" (click)="saveSettings()">
      Guardar Cambios
    </button>
  </ng-template>
</p-dialog>
<div
  class="custom-dialog-overlay"
  *ngIf="displayDialogSettings"
  (click)="hideSettingsDialog()"
></div>

<!-- DIALOG DASHBOARD -->
<p-dialog
  header="Dashboard de Historial"
  [(visible)]="displayDialogDashboard"
  [style]="{ width: '800px', height: '90vh' }"
  [baseZIndex]="10000"
  [modal]="true"
  [draggable]="false"
  (onHide)="hideDashboard()"
>
  <app-dashboard-history
    [storeHistory]="currentHistory"
    [visible]="displayDialogDashboard"
  ></app-dashboard-history>
</p-dialog>
<div
  class="custom-dialog-overlay"
  *ngIf="displayDialogDashboard"
  (click)="hideDashboard()"
></div>

<!-- MANEJO DE CARGANDO -->
<loading-history-drawer
  *ngIf="loadingCreateHistory$ | async"
></loading-history-drawer>

<!-- PARÁMETROS TÉCNICOS -->
<technical-parameters
  [frames]="(framesData$ | async) || []"
  [(visible)]="showTechnicalParametersDialog"
></technical-parameters>

<!-- MANEJO DE ERRORES -->
<ng-container *ngIf="errorCreateHistory$ | async as error">
  <error-history-drawer
    [message]="error"
    (close)="clearErrorHistory()"
    (retry)="retryCreateHistory()"
  >
  </error-history-drawer>
</ng-container>
